import { Reducer } from "redux";
import { IFilterContainerState } from "./filter";
import { IFilterAction, FilterActionTypes } from "./filter.actions";
import { IProductList, IProductListVariant } from "@montana/models/generated/cms.interface";
import { SortingOption } from "@montana/models/dev";

export const initialFilterState: IFilterContainerState = {
    facets: [],
    hits: [],
    appliedFacets: [],
    searchQuery: '',
    sortBy: SortingOption.Manual,
    filterId: 0,
    filterLanguage: '',
    paginationError: false,
    filterError: false,
    isFetchingFilter: false,
    isLoadingMore: false,
};

export const filterReducer: Reducer<IFilterContainerState, IFilterAction> = (state = initialFilterState, action) => {
    switch (action.type) {
        case FilterActionTypes.INIT_FILTER: {
            return {
                ...state,
                filterId: action.filterId,
                filterLanguage: action.filterLanguage,
                isFetchingFilter: true,
            };
        }
        case FilterActionTypes.LOAD_MORE: {
            return {
                ...state,
                isLoadingMore: true,
            };
        }
        case FilterActionTypes.UPDATE_FILTER_RESULT: {
            let productListResult: IProductList;

            if (!action.replace) {
                productListResult = {
                    facets: action.productList.facets,
                    meta: action.productList.meta,
                    hits: [...state.hits || [], ...action.productList.hits || []] as Array<IProductListVariant>,
                }
            } else {
                productListResult = action.productList as IProductList;
            }

            return {
                ...state,
                ...productListResult,
                appliedFacets: action.appliedFacets,
                searchQuery: action.searchQuery,
                sortBy: action.sortBy,
                isFetchingFilter: false,
                isLoadingMore: false,
            };
        }
        default: {
            return state;
        }
    }
}
